import React, { memo, useEffect, useState } from 'react';
import classNames from 'classnames';
import { TEXT, FAKE_DOOR_PATH } from '../../constants';
import styles from './ActionForm.module.scss';
import { ReactComponent as StarIcon } from '../../images/star.svg';
import { ReactComponent as ArmIcon } from '../../images/arms.svg';
import { ReactComponent as SmileIcon } from '../../images/smile.svg';
import { ReactComponent as PriceIcon } from '../../images/price.svg';
import { sendOneManyMiniSubEvent } from '../../events';
import { isEmailCorrect } from './utils';

const {
  form: { title, info, buttonText, additionalInfo, textAfterButton, price },
} = TEXT;

export const ActionForm = memo(function ActionForm({
  isSub = false,
  handleSubmit,
  isVisited,
}: {
  isSub?: boolean;
  handleSubmit: (email: string) => void;
  isVisited: boolean;
}) {
  const [inputValue, setInputValue] = useState('');
  const [isInputCorrect, setInputCorrect] = useState<boolean>(false);
  const [isErrorShow, setErrorShow] = useState<boolean>(false);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setErrorShow(false);
    setInputValue(e.target.value);
  };

  useEffect(() => {
    setInputCorrect(isEmailCorrect(inputValue));
  }, [inputValue]);

  const handleSubmitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!inputValue && !isSub) {
      return;
    }

    if (isInputCorrect || isSub) {
      if (isSub) {
        sendOneManyMiniSubEvent('CLICK_BUY');
        window.location.href = FAKE_DOOR_PATH;
      } else {
        handleSubmit(inputValue);
        // setInputValue('');
      }
    } else {
      setErrorShow(true);
    }
  };

  return (
    <form
      onSubmit={handleSubmitForm}
      className={classNames(
        styles.formWrapper,
        isVisited && styles.formWrapperIsvisited,
        isSub && !isVisited && styles.formWrapperIsSub,
      )}
    >
      {isSub && !isVisited && (
        <div className={styles.priceWrapper}>
          <PriceIcon />
          <span>{price}</span>
        </div>
      )}
      <h4>{title}</h4>
      <ul>
        <div>
          <StarIcon />
          <li>{info.first}</li>
        </div>
        <div>
          <ArmIcon />
          <li>{info.second}</li>
        </div>
        <div>
          <SmileIcon />
          <li>{info.third}</li>
        </div>
      </ul>
      {!isVisited &&
        (isSub ? (
          <span>{additionalInfo}</span>
        ) : (
          <div className={styles.inputWrapper}>
            <input
              name="email"
              required
              placeholder="Ваш email..."
              autoComplete="off"
              value={inputValue}
              onChange={handleInputChange}
            />
            <span className={classNames(isErrorShow && styles.show)}>
              Проверьте, что есть <b>@</b> и <b>.com</b> или <b>.ru</b> в конце
            </span>
          </div>
        ))}
      {!isVisited && (
        <button disabled={isSub ? false : !inputValue} type="submit">
          {isSub ? buttonText.withSub : buttonText.withoutSub}
        </button>
      )}
      {isSub && !isVisited ? <span>{textAfterButton}</span> : null}
    </form>
  );
});
